import React, { Component } from 'react';
import axios from 'axios';
import { handleApiError } from '../utils/errorHandler';
import '../css/App.css';

class TestErrorHandling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    // Test function to simulate KOACH server error
    testKoachServerError = () => {
        this.setState({ loading: true });

        // Make a request to a non-existent KOACH endpoint to trigger server error
        axios.get('https://koach.kauveryhospital.com/non-existent-endpoint-12345')
            .then(response => {
                console.log('Response:', response);
            })
            .catch(error => {
                handleApiError(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    // Test function to simulate internet connectivity error
    testInternetError = () => {
        this.setState({ loading: true });

        // Make a request to a non-existent domain to trigger internet connectivity error
        axios.get('https://non-existent-domain-12345.com/api/test')
            .then(response => {
                console.log('Response:', response);
            })
            .catch(error => {
                handleApiError(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    // Test function to simulate timeout error
    testTimeoutError = () => {
        this.setState({ loading: true });

        // Make a request with very short timeout to trigger timeout error
        axios.get('https://koach.kauveryhospital.com/userlogin_beta', {
            timeout: 1 // 1ms timeout to force timeout error
        })
            .then(response => {
                console.log('Response:', response);
            })
            .catch(error => {
                handleApiError(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    // Test function to simulate 404 error
    test404Error = () => {
        this.setState({ loading: true });

        // Make a request to a valid domain but non-existent endpoint
        axios.get('https://httpbin.org/status/404')
            .then(response => {
                console.log('Response:', response);
            })
            .catch(error => {
                handleApiError(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        return (
            <div className="container" style={{ padding: '20px' }}>
                <h2>Error Handling Test Page</h2>
                <p>This page is for testing the new error handling functionality.</p>
                
                <div style={{ marginBottom: '20px' }}>
                    <button
                        className="btn btn-danger"
                        onClick={this.testKoachServerError}
                        disabled={this.state.loading}
                        style={{ marginRight: '10px', marginBottom: '10px' }}
                    >
                        {this.state.loading ? 'Testing...' : 'Test KOACH Server Error'}
                    </button>

                    <button
                        className="btn btn-warning"
                        onClick={this.testInternetError}
                        disabled={this.state.loading}
                        style={{ marginRight: '10px', marginBottom: '10px' }}
                    >
                        {this.state.loading ? 'Testing...' : 'Test Internet Error'}
                    </button>

                    <button
                        className="btn btn-info"
                        onClick={this.testTimeoutError}
                        disabled={this.state.loading}
                        style={{ marginRight: '10px', marginBottom: '10px' }}
                    >
                        {this.state.loading ? 'Testing...' : 'Test Timeout Error'}
                    </button>

                    <button
                        className="btn btn-secondary"
                        onClick={this.test404Error}
                        disabled={this.state.loading}
                        style={{ marginBottom: '10px' }}
                    >
                        {this.state.loading ? 'Testing...' : 'Test 404 Error'}
                    </button>
                </div>

                <div className="alert alert-info">
                    <strong>Expected behavior:</strong>
                    <ul>
                        <li><strong>KOACH Server Error:</strong> "Unable to connect KOACH server, try after sometime. For further queries please contact the KOACH administrator at 9940287705"</li>
                        <li><strong>Internet Error:</strong> "Internet not available. Please check your internet connection and try again."</li>
                        <li><strong>Timeout Error:</strong> "Request timed out. Please check your connection and try again."</li>
                        <li><strong>404 Error:</strong> "The requested resource was not found."</li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default TestErrorHandling;
